import EventEmitter from './EventEmitter';
import  Stats from 'stats.js';
import * as THREE from 'three';

export default class Time extends EventEmitter {
    constructor() {
        super();

        this.start = Date.now();
        this.current = this.start;
        this.elapsed = 0;
        this.delta = 16;
        this.stats = new Stats();
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);

        this.fpsInterval = 1000 / 24;
        this.then = Date.now();
        this.startTime = this.then;

        window.requestAnimationFrame(this.tick.bind(this));
    }

    tick(){
        this.stats.begin();

        this.now = Date.now();
        this.elapsed = this.now - this.then;
        if (this.elapsed > this.fpsInterval) {

            // Get ready for next frame by setting then=now, but also adjust for your
            // specified fpsInterval not being a multiple of RAF's interval (16.7ms)
            this.then = this.now - (this.elapsed % this.fpsInterval);
            this.trigger('tick');
            this.stats.end();
        }

        window.requestAnimationFrame(this.tick.bind(this));

    }
}